import React from 'react'
import useStyles from './Style'
import { Box, Container } from '@mui/material'
import CustomTypo from './CustomTypo/CustomTypo'

import { Nunito_Sans, Lato } from '@next/font/google'
import { contentType } from 'src/types/components/shared/atom'
import { ButtonComponent } from 'src/components/shared/atoms'
import Blobs from 'src/components/shared/modules/blobs'

const nunito_sans = Nunito_Sans({
  weight: ['400', '700', '800'],
  subsets: ['latin'],
})

const lato = Lato({
  weight: '400',
  subsets: ['latin'],
})

interface HeroHeaderProps {
  content: contentType
  homeIcon?: boolean
  placeHolder: string
  endAdornment?: boolean
  zenMode?: boolean
}

const HeroHeader: React.FC<HeroHeaderProps> = ({
  content,
  homeIcon,
  zenMode,
}) => {
  const { classes } = useStyles()
  const handleClickScroll = () => {
    const element = document.getElementById('collaborate_form')
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const ContentUI: JSX.Element[] | '' | 0 = Object.keys(content.content)
    ? Object.keys(content.content).length &&
      Object.keys(content.content).map((curr, index) => (
        <CustomTypo
          key={index}
          icon={homeIcon}
          className={
            content.content[curr].type === 'tertiary'
              ? lato.className
              : nunito_sans.className
          }
          content={content.content[curr].content}
          variant={content.content[curr].variant}
          type={content.content[curr].type}
        />
      ))
    : ''
  // ${classes.bgWithCss} bg with csss

  return (
    <Box className={`${classes.rootContainer} ${nunito_sans.className}`}>
      {!zenMode && <Blobs />}

      <Container className={classes.contentContainer} disableGutters>
        {ContentUI}
      </Container>

      <Box className={classes.btnContainer}>
        {' '}
        {content?.button && (
          <ButtonComponent
            type="contained"
            text={content?.button[0].content}
            onClick={handleClickScroll}
            className={classes.recommendBtn}
            wrapperClass={classes.gradientWrapper}
            gradient
          />
        )}
      </Box>
    </Box>
  )
}

export default HeroHeader
